import React from 'react';

//CORE COMPONENTS
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container/index';
import { Text, TextAppearance } from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import { AspectRatioContainer, AspectRatio } from '../../../components-core/packages/components-core/dist/aspect-ratio-container/index';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';

//CUSTOM COMPONENTS
import { TopContainer } from '../../helpers/ComponentHelpers';


class ModelDetailParagraph extends React.Component {

    renderSectionUp() {
        const { custom } = this.props;
        return (
            <Container 
                wrap={ContainerWrap.always} 
                padding={sectionUpContainerPadding} 
                gutter={ContainerGutter.dynamic0100}
            >
                <Text appearance={TextAppearance.headline0350} bold>
                    {custom}
                    <Text bold>{''} </Text>
                </Text>
                <Container padding={titleDescriptionContainerPadding} >
                    <Text>
                        Tüm ailenin çıktığı en heyecanlı yolculuklar, DSG teknolojisiyle kesintisiz sürüş keyfi veriyor.
                    </Text>
                </Container>
            </Container>
        )
    }

    renderSectionLeft() {
        return (
            <Container stretchContent={true} padding={sectionLeftContainerPadding}>
                <AspectRatioContainer ratio={AspectRatio['4:3']}>
                    <Image 
                        src={'https://cdn.zeplin.io/5e5ab739856bf664cdf01f04/assets/C8992FC7-71C7-4AF2-85C3-E44D5D121A1C.png'} 
                        alt={'vw-paragraph'}
                    />
                </AspectRatioContainer>
            </Container>
        )
    }

    renderSectionRight() {
        const { 
            custom1, 
            custom2, 
            custom3, 
            custom4, 
            custom5, 
            custom6 
        } = this.props;

        return (
            <Container padding={sectionRightContainerPadding}>
                <Container padding={{ bottom: ContainerPadding.dynamic0100 }} >
                    {renderSmallText(custom1, true)}
                    {renderSmallText(custom4, false)}
                </Container>
                <Container padding={{ bottom: ContainerPadding.dynamic0100 }}>
                    {renderSmallText(custom2, true)}
                    {renderSmallText(custom5, false)}
                </Container>
                <Container padding={{ bottom: ContainerPadding.dynamic0100 }}>
                    {renderSmallText(custom3, true)}
                    {renderSmallText(custom6, false)}
                </Container>
            </Container>
        )
    }

    render() {
        return (
            <TopContainer>
                {this.renderSectionUp()}
                <Layout appearance={layoutAppearance}>
                    {this.renderSectionLeft()}
                    {this.renderSectionRight()}
                </Layout>
            </TopContainer>
        )
    }
}

const renderSmallText = (text, bold) => (
    <Container padding={{ bottom: bold ? ContainerPadding.static150 : ContainerPadding.dynamic0020 }}>
        <Text bold={bold} wordBreak appearance={TextAppearance.copy0150}>
            {text}
        </Text>
    </Container>
)

const sectionUpContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: ContainerPadding.grid007
    },
    bottom: {
        [Breakpoints.default]: ContainerPadding.dynamic0200
    } 
}

const titleDescriptionContainerPadding = { 
    left: {
        [Breakpoints.b560]: ContainerPadding.grid001,
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid001,
        [Breakpoints.b560]: ContainerPadding.grid008
    } 
}

const layoutAppearance = {
    [Breakpoints.default]: [
        { name: 'a', columns: 24},
        { name: 'b', columns: 24}
    ],
    [Breakpoints.b960]: [
        {name: '.', columns: 2},
        {name: 'a', columns: 10},
        {name: 'b', columns: 10},
        {name: '.', columns: 2}
    ],
    [Breakpoints.b1920]: [
        {name: '.', columns: 4},
        {name: 'a', columns: 8},
        {name: 'b', columns: 8},
        {name: '.', columns: 4}
    ]
}

const sectionLeftContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: null
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: ContainerPadding.grid001
    },
    bottom: {
        [Breakpoints.default]: ContainerPadding.dynamic0100,
        [Breakpoints.b960]: null
    }
}

const sectionRightContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: null
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid005,
        [Breakpoints.b960]: null
    }
}

export default ModelDetailParagraph;



const sampelBoldText1 = '6 ileri DSG otomatik şanzıman';
const sampleRegulerText1 = 'Volkswagen tarafından geliştirilmiş 6 ileri DSG otomatik şanzıman, vites aralıklarını milisaniyeler içerisinde değişecek şekilde küçülterek daha yumuşak vites geçişleri ile sürüş konforunuzu arttırıyor.'

const sampleBoldText2 = 'Tiptronik özelliği ile manuel vites değiştirme imkanı';
const sampleRegulerText2 = 'DSG otomatik şanzımanda bulunan tiptronik özelliği, sportif kullanımı tercih edenler için vitesi manuel değiştirme olanağı sağlıyor.';